import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { RdsChipsModule } from '../chips/index';
import { RdsFiltersToChipsPipe } from './numeric-filter-chips.pipe';
import { RdsNumericFilterComponent } from './numeric-filter.component';

const COMPONENTS = [RdsNumericFilterComponent];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    RdsChipsModule
  ],
  exports: [COMPONENTS],
  declarations: [COMPONENTS, RdsFiltersToChipsPipe]
})
export class RdsNumericFilterModule {}

export * from './numeric-filter.component';
export * from './numeric-filter.model';
